import { render, staticRenderFns } from "./PreviousPromotionsCard.vue?vue&type=template&id=7a79f92e&scoped=true"
import script from "./PreviousPromotionsCard.vue?vue&type=script&lang=js"
export * from "./PreviousPromotionsCard.vue?vue&type=script&lang=js"
import style0 from "./PreviousPromotionsCard.vue?vue&type=style&index=0&id=7a79f92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a79f92e",
  null
  
)

export default component.exports